/**
 * Lists the possible states of a file.
 */
export var UploadFileStatus;

(function (UploadFileStatus) {
  /**
   * Indicates that the file upload process has failed.
   */
  UploadFileStatus[UploadFileStatus["UploadFailed"] = 0] = "UploadFailed";
  /**
   * An initially selected fake file without a set state.
   */

  UploadFileStatus[UploadFileStatus["Initial"] = 1] = "Initial";
  /**
   * The file is selected.
   */

  UploadFileStatus[UploadFileStatus["Selected"] = 2] = "Selected";
  /**
   * The file is in the process of uploading.
   */

  UploadFileStatus[UploadFileStatus["Uploading"] = 3] = "Uploading";
  /**
   * The file is successfully uploaded.
   */

  UploadFileStatus[UploadFileStatus["Uploaded"] = 4] = "Uploaded";
  /**
   * The remove process has failed.
   */

  UploadFileStatus[UploadFileStatus["RemoveFailed"] = 5] = "RemoveFailed";
  /**
   * The file is in the process of removing.
   */

  UploadFileStatus[UploadFileStatus["Removing"] = 6] = "Removing";
})(UploadFileStatus || (UploadFileStatus = {}));